<template>
  <div class="central-div">
    <AuthView />
  </div>
</template>

<script>
import AuthView from "@/views/AuthView";

export default {
  components: {
    AuthView,
  },
};
</script>

<style scoped>
.central-div {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>